import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import AppText from "../../../../_shared/components/AppText";

import list from "../../../Finishes/list.js";

import { Modal } from "antd";
import BackIcon from "../../../../_shared/components/BackIcon";
import CloseIcon from "../../../../_shared/components/CloseIcon";

import SlideImages from "../../../../_shared/components/SlideImages";
import useRestList from "../../../../_shared/hooks/useRestList";

// ----------------------------------------------------------------------------

export default function SystemFinishesPage(props) {
  // -------------------------------------
  // Props Destructuring
  // -------------------------------------

  const { onClose, finishesId } = props;

  const [allFabrics] = useRestList("/fabrics");

  // -------------------------------------
  // Hooks
  // -------------------------------------

  const [finishes, setFinishes] = useState();
  const [modalFinishes, setModalFinishes] = useState();
  const [modalIndex, setModalIndex] = useState();
  const [areFabrics, setAreFabrics] = useState(finishesId === 99);

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    if (finishesId === 99) {
    } else {
      setFinishes(list?.filter((x) => finishesId.includes(x.id)));
    }
  }, [finishesId]);

  function openFin(subcat, index) {
    setModalFinishes(subcat?.finishes);

    setModalIndex(index);
  }

  return (
    <Modal
      open={true}
      closable={false}
      centered
      footer={[]}
      className="modal"
      bodyStyle={{ maxHeight: "85vh", overflow: "auto" }}
    >
      <div
        className="root"
        style={{ backgroundColor: "white", height: "100vh" }}
      >
        <div className="row" style={{ marginBottom: 10 }}>
          <BackIcon onClick={onClose}></BackIcon>
          <div
            className="row"
            style={{ height: 25, display: "flex", alignItems: "center" }}
          >
            <AppText bold>Finiture e colori</AppText>
            <AppText light>/ Finishes and colours</AppText>
          </div>
        </div>
        {finishesId === 99
          ? allFabrics
              ?.filter((main) => main?.parentFabric === undefined)
              ?.map((mainCat) => (
                <div>
                  <AppText small bold>
                    {mainCat?.name?.it}
                  </AppText>
                  <AppText small light>
                    {mainCat?.name?.en}
                  </AppText>
                  <div className="rowFinishes">
                    {allFabrics
                      ?.filter((sub) => sub?.parentFabric?.id === mainCat?.id)
                      ?.map((subcat, index) => (
                        <div
                          className="finishCard"
                          onClick={() => openFin(mainCat, index)}
                        >
                          <img
                            alt=""
                            src={subcat?.image}
                            style={{ height: 140, width: 100 }}
                          ></img>
                          <div className="row">
                            <AppText xsmall bold>
                              {subcat?.name?.it}
                            </AppText>
                          </div>
                          <AppText xsmall light>
                            {subcat?.description}
                          </AppText>
                        </div>
                      ))}
                  </div>
                </div>
              ))
          : finishes?.map((mainCat) => (
              <div>
                <AppText small bold>
                  {mainCat?.name?.it}
                </AppText>
                <AppText small light>
                  {mainCat?.name?.en}
                </AppText>
                <div className="rowFinishes">
                  {mainCat?.finishes?.map((subcat, index) => (
                    <div
                      className="finishCard"
                      onClick={() => openFin(mainCat, index)}
                    >
                      <img
                        alt=""
                        src={subcat?.image}
                        style={{ height: 140, width: 100 }}
                      ></img>
                      <div className="rowNoSpace">
                        <AppText xsmall bold>
                          {subcat?.name}
                        </AppText>
                      </div>
                      <AppText xsmall light>
                        {subcat?.description}
                      </AppText>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        <Modal
          closable={false}
          footer={[]}
          centered
          className="modal"
          open={modalFinishes}
          bodyStyle={{ height: "85vh", overflowY: "auto" }}
        >
          <div
            style={{
              alignSelf: "flex-end",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CloseIcon onClick={() => setModalFinishes()}></CloseIcon>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "35%",
            }}
          >
            <SlideImages
              image={modalFinishes?.[modalIndex]?.image}
              onPlus={() =>
                modalFinishes.length > modalIndex + 1
                  ? setModalIndex(modalIndex + 1)
                  : setModalIndex(0)
              }
              onMinus={() =>
                modalIndex !== 0
                  ? setModalIndex(modalIndex - 1)
                  : setModalIndex(modalFinishes?.length - 1)
              }
              showArrows={modalFinishes?.length > 1}
              style={{
                width: "30vw",
                objectFit: "cover",
                height: "70vh",
              }}
              noCenter
              noContain
            ></SlideImages>
            <div style={{ marginTop: 10 }}>
              <div className="row">
                {modalFinishes?.[modalIndex]?.code && (
                  <AppText small bold>
                    {modalFinishes?.[modalIndex]?.code}
                  </AppText>
                )}
                <AppText small bold>
                  {modalFinishes?.[modalIndex]?.name}
                </AppText>
              </div>
              <AppText small light>
                {modalFinishes?.[modalIndex]?.description}
              </AppText>
            </div>
          </div>
        </Modal>
      </div>
    </Modal>
  );
}
